import { ReloadOutlined } from '@ant-design/icons'
import { useApolloClient } from '@apollo/client'
import { Button, Tooltip } from 'antd'
import localforage from 'localforage'
import React from 'react'

const apolloCacheStorage = localforage.createInstance({
  name: 'wdn-admin-v2',
  storeName: 'apollo-cache',
})

const PurgeCache = () => {
  const client = useApolloClient()

  const onPurge = async () => {
    await client.clearStore()
    await localforage.clear()
    await apolloCacheStorage.clear()
    window.location.reload()
  }

  return (
    <Tooltip title="Purge cache">
      <Button
        className="d-flex align-items-center justify-content-center"
        shape="circle"
        onClick={onPurge}
        type="text"
        icon={
          <ReloadOutlined
            style={{
              color: '#fff',
            }}
          />
        }
      />
    </Tooltip>
  )
}
export default PurgeCache
